export const Footer = () => {
  return (
    <>
      <footer className="footer d-flex">
        <div className="footer-bottom">
          <div className="container">
            <span className="copyright">
              &copy; 2023 FUZZYJARR |
              <a
                href="https://jarrexchange.netlify.app/"
                target="_blank"
                rel="noopener noreferrer"
                className="copyright-link"
              >
                JARR
              </a>
            </span>
          </div>
        </div>
      </footer>
    </>
  )
}
